import React from 'react'
import Slider from 'react-slick'

export default class Spotlight extends React.Component {
	render() {
		const settings = {
			dots: false,
			infinite: true,
			speed: 200,
			slidesToShow: this.props.slidesToShow || 3,
			slidesToScroll: 1,
			swipeToSlide: true,
			pauseOnHover: true,
			pauseOnFocus: true,
			arrows: this.props.arrows || false,
			autoplay: this.props.autoPlay === undefined ? false : this.props.autoPlay,
			responsive: this.props.responsive || null,
			variableWidth: this.props.variableWidth || false
		};
		const items = this.props.items.map(item =>
			<div key={item.id} className="item">
				{this.props.renderItem(item, item.id)}
			</div>
		);

		return (
			<div className={classNames("spotlight", this.props.className || null)}>
				<Slider {...settings}>
					{items}
				</Slider>
			</div>
		);
	}
}
